import { render, staticRenderFns } from "./BarContactForm.vue?vue&type=template&id=79dc29f8&scoped=true"
import script from "./BarContactForm.vue?vue&type=script&lang=js"
export * from "./BarContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc29f8",
  null
  
)

export default component.exports